<template>
  <nav-item
    class="ai-chat-nav-chat"
    :title="title"
    icon="chat"
    :active="active"
    hover-color="beige"
    @click="$emit('select')"
  >
    <template #actions>
      <ai-chat-chat-menu
        xs
        :chat-id="chat.uid"
      />
    </template>
  </nav-item>
</template>

<script setup>
import AiChatChatMenu from '@/components/ai-chat/AiChatChatMenu.vue';
import NavItem from '@/components/navigation/NavItem.vue';
import { chatTitle } from '@/lib/ai-chat-list';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  chat: {
    type: Object,
    required: true,
  },
  active: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['select']);

const { t } = useI18n();

const title = computed(() => chatTitle(props.chat, t('aiChat.untitled')));
</script>
